import {  createSlice } from '@reduxjs/toolkit';
import { deviceSurveyAPI, deviceSurveyStartAPI, deviceSurveyStepAPI, deviceSurveyPreviousStepAPI  } from '../api/surveyAPI';

const initialState = {
  surveyStartError: null,
  surveyStartSuccess: null,
};

export const surveySlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    surveyStartError(state, action){
      state.surveyStartError = action.payload
    },
    surveyStartSuccess(state, action){
      state.survey = action.payload
      sessionStorage.setItem('survey', action.payload.surveyId)
      sessionStorage.setItem('step', action.payload.stepId)
    },
  },
});

export const { surveyStartError, surveyStartSuccess} = surveySlice.actions;

export const deviceSurvey =  (id, surveyId, stepId, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceSurveyAPI(id, surveyId, stepId)
    if(callback) callback(response)
    if(response){
      dispatch(surveyStartSuccess(response))
    }
    return response;
  } catch (forgetError) {
    dispatch(surveyStartError(forgetError))
  }
};
export const deviceSurveyStart =  (id, data, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceSurveyStartAPI(id, data)
    if(response){
      dispatch(surveyStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(surveyStartError(forgetError))
  }
};
export const deviceSurveyStep =  (id, data, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceSurveyStepAPI(id, data)
    if(response){
      dispatch(surveyStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(surveyStartError(forgetError))
  }
};
export const deviceSurveyPreviousStep =  (id, surveyId, callback) => async (dispatch, getState) => {
  try{
    const response = await deviceSurveyPreviousStepAPI(id, surveyId)
    if(response){
      dispatch(surveyStartSuccess(response))
    }
    if(callback) callback(response)
    return response;
  } catch (forgetError) {
    dispatch(surveyStartError(forgetError))
  }
};

export default surveySlice.reducer;
